import { Message } from 'element-ui';

// 获取当天开始时间戳
export const getTodayStartTimestamp = () => {
  const date = new Date();
  date.setHours(0);
  date.setMinutes(0);
  date.setSeconds(0);
  date.setMilliseconds(0);

  return date.getTime();
};
// 获取当天末尾时间戳
export const getTodayEndTimestamp = () => {
  const date = new Date();
  // date.setHours(23);
  // date.setMinutes(59);
  // date.setSeconds(59);
  // date.setMilliseconds(59);
  return date.getTime();
};
export const getTodayEndTimestampLast = () => {
  const date = new Date();
  date.setHours(23);
  date.setMinutes(59);
  date.setSeconds(59);
  date.setMilliseconds(59);
  return date.getTime();
};
// 获取七天前开始时间戳
export const getSevenTimestamp = () => {
  const date = new Date();
  date.setHours(0);
  date.setMinutes(0);
  date.setSeconds(0);
  date.setMilliseconds(0);
  date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
  return date.getTime();
};
// 获取30天前开始时间戳
export const getThirtyTimestamp = () => {
  const date = new Date();
  date.setHours(0);
  date.setMinutes(0);
  date.setSeconds(0);
  date.setMilliseconds(0);
  date.setTime(date.getTime() - 3600 * 1000 * 24 * 30);
  return date.getTime();
};


// 将时间戳转换成时间
function formatNumber(n) {
  n = n.toString();
  return n[1] ? n : `0${n}`;
}


export const formatDate = (time) => {
  const now = new Date(time);
  const year = formatNumber(now.getFullYear());
  const month = formatNumber(now.getMonth() + 1);
  const date = formatNumber(now.getDate());
  // const hour = formatNumber(now.getHours());
  // const minute = formatNumber(now.getMinutes());
  // const second = formatNumber(now.getSeconds());
  return `${year}-${month}-${date}`;
};

export const formatDatehour = (time) => {
  const now = new Date(time);
  const year = formatNumber(now.getFullYear());
  const month = formatNumber(now.getMonth() + 1);
  const date = formatNumber(now.getDate());
  const hour = formatNumber(now.getHours());
  const minute = formatNumber(now.getMinutes());
  const second = formatNumber(now.getSeconds());
  return `${year}-${month}-${date} ${hour}:${minute}:${second}`;
};

export const formatDateEndhour = (time) => {
  const now = new Date(time);
  const year = formatNumber(now.getFullYear());
  const month = formatNumber(now.getMonth() + 1);
  const date = formatNumber(now.getDate());
  return `${year}-${month}-${date} 23:59:59`;
};

// 获得某月的天数
export const getMonthDays = (year, month) => {
  // 本月第一天 1-31
  const relativeDate = new Date(year, month, 1);
  // 获得当前月份0-11
  let relativeMonth = relativeDate.getMonth();
  // 获得当前年份4位年
  let relativeYear = relativeDate.getFullYear();

  // 当为12月的时候年份需要加1 月份需要更新为0 也就是下一年的第一个月
  if (relativeMonth === 11) {
    relativeYear += 1;
    relativeMonth = 0;
  } else {
    // 否则只是月份增加,以便求的下一月的第一天
    relativeMonth += 1;
  }
  // 一天的毫秒数
  const millisecond = 1000 * 60 * 60 * 24;
  // 下月的第一天
  const nextMonthDayOne = new Date(relativeYear, relativeMonth, 1);
  // 返回得到上月的最后一天,也就是本月总天数
  return new Date(nextMonthDayOne.getTime() - millisecond).getDate();
};
// 返回上一个月的第一天Date类型
const getPriorMonthFirstDay = (year, month) => {
  // 年份为0代表,是本年的第一月,所以不能减
  if (month === 0) {
    return new Date(year - 1, 11, 1);
  }
  // 否则,只减去月份
  return new Date(year, month - 1, 1);
};

// 获取上一周的方法
export const getLastWeek = () => {
  const result = {
    startDate: null,
    endDate: null,
  };
  const day = new Date();// 获取当前时间
  const week = day.getDay();
  const millisecond = 1000 * 60 * 60 * 24; // 一天的毫秒数
  const minusDay = week !== 0 ? week - 1 : 6; // 减去的天数
  // 获得当前周的第一天
  const currentWeekDayOne = new Date(day.getTime() - (millisecond * minusDay));
  // 上周最后一天即本周开始的前一天
  const priorWeekLastDay = new Date(currentWeekDayOne.getTime() - millisecond);
  priorWeekLastDay.setHours(23);
  priorWeekLastDay.setMinutes(59);
  priorWeekLastDay.setSeconds(59);
  priorWeekLastDay.setMilliseconds(59);

  // 上周的第一天
  const priorWeekFirstDay = new Date(priorWeekLastDay.getTime() - (millisecond * 6));
  priorWeekFirstDay.setHours(0);
  priorWeekFirstDay.setMinutes(0);
  priorWeekFirstDay.setSeconds(0);
  priorWeekFirstDay.setMilliseconds(0);

  result.startDate = priorWeekFirstDay;
  result.endDate = priorWeekLastDay;
  return result;
};
// 获取上一月的方法
export const getLastMonth = () => {
  const result = {
    startDate: null,
    endDate: null,
  };
  const day = new Date();
  // 获得当前月份0-11
  const currentMonth = day.getMonth();
  // 获得当前年份4位年
  const currentYear = day.getFullYear();
  // 获得上一个月的第一天
  const priorMonthFirstDay = getPriorMonthFirstDay(currentYear, currentMonth);
  priorMonthFirstDay.setHours(0);
  priorMonthFirstDay.setMinutes(0);
  priorMonthFirstDay.setSeconds(0);
  priorMonthFirstDay.setMilliseconds(0);

  // 获得上一月的最后一天
  const priorMonthLastDay = new Date(priorMonthFirstDay.getFullYear(),
    priorMonthFirstDay.getMonth(),
    getMonthDays(priorMonthFirstDay.getFullYear(), priorMonthFirstDay.getMonth()));
  priorMonthLastDay.setHours(23);
  priorMonthLastDay.setMinutes(59);
  priorMonthLastDay.setSeconds(59);
  priorMonthLastDay.setMilliseconds(59);

  result.startDate = priorMonthFirstDay;
  result.endDate = priorMonthLastDay;
  return result;
};

export const debounce = (func, wait, immediate) => {
  let timeout;
  return (...args) => {
    const context = this;
    if (timeout) clearTimeout(timeout);

    if (immediate) {
      const callNow = !timeout;
      timeout = setTimeout(() => {
        timeout = null;
      }, wait);
      if (callNow) func.apply(context, args);
    } else {
      timeout = setTimeout(() => {
        func.apply(context, args);
      }, wait);
    }
  };
};

export const downLoadFileByForm = (url, obj) => {
  const tempForm = document.createElement("form");
  tempForm.name = "myform";
  tempForm.id = "myform";
  tempForm.action = url;
  tempForm.method = "post";
  tempForm.target = "form";
  tempForm.style.display = "none";
  const keys = Object.keys(obj);
  keys.forEach((key) => {
    const opt = document.createElement("input");
    opt.name = key;
    opt.value = obj[key];
    if (key === "pageSize") opt.value = 10;
    if (opt.value !== "") {
      tempForm.appendChild(opt);
    }
  });
  const opt = document.createElement("button");
  opt.type = "submit";
  opt.id = "submit";
  tempForm.appendChild(opt);
  document.body.appendChild(tempForm);

  const iframe = document.createElement("iframe");
  iframe.name = "form";
  iframe.id = "jForm";
  iframe.style.display = "none";
  document.body.appendChild(iframe);

  opt.click();
  document.querySelector('#jForm').addEventListener('load', () => {
    const content = document.querySelector('#jForm').contentDocument.body.innerHTML;
    if (content) {
      Message({
        showClose: true,
        message: content.split(',')[1].split(":")[1].replace(/"/g, ''),
        type: "error",
      });
    }
    document.body.removeChild(tempForm);
    document.body.removeChild(iframe);
  });
};

export const getAccessRouter = (localRouter, remoteRouter) => {
  const newLocalRouter = [];
  // console.log(remoteRouter, "remoteRouter");
  if (remoteRouter) {
    remoteRouter.forEach((v) => {
      for (let i = 0; i < localRouter.length; i++) {
        const item = localRouter[i];
        if (v.path === item.path) {
          const result = {};
          // 判断是否有children
          if (v.children && v.children.length) {
            result.path = item.path;
            result.name = item.name;
            result.component = item.component;
            result.meta = item.meta;

            if (item.redirect) {
              result.redirect = item.redirect;
            }
            if (item.alwaysShow) {
              result.alwaysShow = item.alwaysShow;
            }
            if (item.hidden) {
              result.hidden = item.hidden;
            }
            result.children = getAccessRouter(item.children, v.children);

            newLocalRouter.push(result);
          } else {
            result.path = item.path;
            result.name = item.name;
            result.component = item.component;
            result.meta = item.meta;

            if (item.redirect) {
              result.redirect = item.redirect;
            }
            if (item.alwaysShow) {
              result.alwaysShow = item.alwaysShow;
            }
            if (item.hidden) {
              result.hidden = item.hidden;
            }

            newLocalRouter.push(result);
          }
          break;
        }
      }
    });
  }
  return newLocalRouter;
};
